"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.fromCosmosResourcesRaw = exports.toCosmosResourcesRaw = void 0;
const bignumber_js_1 = require("bignumber.js");
function toCosmosResourcesRaw(r) {
    const { delegatedBalance, delegations, pendingRewardsBalance, unbondingBalance, withdrawAddress, redelegations, unbondings, } = r;
    return {
        delegations: delegations.map(({ amount, status, pendingRewards, validatorAddress }) => ({
            amount: amount.toString(),
            status,
            pendingRewards: pendingRewards.toString(),
            validatorAddress,
        })),
        redelegations: redelegations.map(({ amount, completionDate, validatorSrcAddress, validatorDstAddress }) => ({
            amount: amount.toString(),
            completionDate: completionDate.toString(),
            validatorSrcAddress,
            validatorDstAddress,
        })),
        unbondings: unbondings.map(({ amount, completionDate, validatorAddress }) => ({
            amount: amount.toString(),
            completionDate: completionDate.toString(),
            validatorAddress,
        })),
        delegatedBalance: delegatedBalance.toString(),
        pendingRewardsBalance: pendingRewardsBalance.toString(),
        unbondingBalance: unbondingBalance.toString(),
        withdrawAddress,
    };
}
exports.toCosmosResourcesRaw = toCosmosResourcesRaw;
function fromCosmosResourcesRaw(r) {
    const { delegatedBalance, delegations, pendingRewardsBalance, redelegations, unbondingBalance, withdrawAddress, unbondings, } = r;
    return {
        delegations: delegations.map(({ amount, status, pendingRewards, validatorAddress }) => ({
            amount: new bignumber_js_1.BigNumber(amount),
            status,
            pendingRewards: new bignumber_js_1.BigNumber(pendingRewards),
            validatorAddress,
        })),
        redelegations: redelegations.map(({ amount, completionDate, validatorSrcAddress, validatorDstAddress }) => ({
            amount: new bignumber_js_1.BigNumber(amount),
            completionDate: new Date(completionDate),
            validatorSrcAddress,
            validatorDstAddress,
        })),
        unbondings: unbondings.map(({ amount, completionDate, validatorAddress }) => ({
            amount: new bignumber_js_1.BigNumber(amount),
            completionDate: new Date(completionDate),
            validatorAddress,
        })),
        delegatedBalance: new bignumber_js_1.BigNumber(delegatedBalance),
        pendingRewardsBalance: new bignumber_js_1.BigNumber(pendingRewardsBalance),
        unbondingBalance: new bignumber_js_1.BigNumber(unbondingBalance),
        withdrawAddress,
    };
}
exports.fromCosmosResourcesRaw = fromCosmosResourcesRaw;
function assignToAccountRaw(account, accountRaw) {
    const cosmosAccount = account;
    if (cosmosAccount.cosmosResources) {
        accountRaw.cosmosResources = toCosmosResourcesRaw(cosmosAccount.cosmosResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    const cosmosResourcesRaw = accountRaw.cosmosResources;
    if (cosmosResourcesRaw)
        account.cosmosResources = fromCosmosResourcesRaw(cosmosResourcesRaw);
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map